document.addEventListener("DOMContentLoaded", async () => {

  /*const res =  fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    });*/
 
// custom.js
// Cart Data Fetcher to verify stitches
  async function getCartData() {
  try {
    const response = await fetch('/cart.js');
    
    if (!response.ok) {
      throw new Error(`Failed to fetch cart: ${response.status}`);
    }
    
    const cart = await response.json();
    
    console.log("=== CART VERIFICATION ===");
    console.log("Raw cart data:", cart);
    
    const processedItems = cart.items.map(item => {
      return {
        id: item.id,
        product_title: item.product_title,
        quantity: item.quantity,
        tags: item.tags,
        properties: item.properties || {}
      };
    });
    
    return {
      success: true,
      items: processedItems
    };
    
  } catch (error) {
    console.error('Cart fetch error:', error);
    return {
      success: false,
      error: error.message,
      items: []
    };
  }
}

// Function to handle stitches calculation and logo service addition
  async function handleStitchesLogoService(item) {
  const Stitchesranges = [
    { min: 1, max: 6000 },
    { min: 6001, max: 7000 },
    { min: 7001, max: 8000 },
    { min: 8001, max: 9000 },
    { min: 9001, max: 10000 }
  ];

  const quantityranges = [
    { min: 1, max: 5 },
    { min: 6, max: 11 },
    { min: 12, max: 23 },
    { min: 24, max: 47 },
    { min: 48, max: 71 },
    { min: 72, max: 143 },
    { min: 144, max: 499 },
    { min: 500, max: 500 }
  ];

 

  if(item.properties['Text'] && item.properties['Text'].length > 0)
  {

     
    const variantid2 = 45660334522556;
   await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantid2,         
          quantity: item.quantity*(item.properties['Text'].length),
           
        })
      });
  }
  

  if (!item.properties['Logo Stitches']) {
    console.log("❌ NO STITCHES FOUND");
    return;
  }

  console.log("✅ STITCHES FOUND:", item.properties['Logo Stitches']);

  try {
    // Fetch logo service product data
    const response = await fetch('/products/logo-service.js');
    const product = await response.json();

    function findVariant(val1, val2, val3) {
      return product.variants.find(v =>
        v.option1 == val1 &&
        v.option2 == val2 &&
        v.option3 == val3
      );
    }

    // Determine stitches range
    const stitchesmain = Stitchesranges.find(function(r) {
      return item.properties['Logo Stitches'] >= r.min && 
             item.properties['Logo Stitches'] <= r.max;
    });

    const stitches = stitchesmain?.max;

    // Determine quantity range
    const qtymain = quantityranges.find(function(r) {
      return item.quantity >= r.min && item.quantity <= r.max;
    });

    const qty = qtymain?.max;

    // Determine product type
      const type = (function () {
        const titleLower = item.product_title?.toLowerCase() || "";
        const typeLower = item.product_type?.toLowerCase() || "";
        const tagsLower = (item.tags || []).join(",").toLowerCase();
        const propsLower = JSON.stringify(item.properties || {}).toLowerCase();

        const combined = [titleLower, typeLower, tagsLower, propsLower].join(",");

        // Detect blazer
        if (combined.includes("blazer")) return "Blazer";

        // Detect outerwear
        if (combined.includes("outerwear")) return "Outerwear";

        return "Standard";
      })();

    // alert(type);
    // Find matching variant
    const variant = findVariant(stitches, qty, type);

    if (variant) {
      console.log("Found Variant:", variant);
      console.log("Variant ID:", variant.id);
      console.log("Variant Price:", variant.price / 100);

      // Add logo service to cart
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variant.id,         
          quantity: item.quantity,
          properties: {
            'Linked Item ID': item.id,
            //'Logo Stitches': item.properties['Logo Stitches'],
           // 'Logo Image URL': item.properties['Logo Image URL'],
             'parent_id': item.key
          }
        })
      });

      return true;
    } else {
      console.log("Variant not found");
      return false;
    }

  } catch (error) {
    console.error("Error handling stitches logo service:", error);
    return false;
  }
}

// Main function to process cart after adding item
window.processCartAfterAdd = async function () {

showLoader();
  const productId = 9067457249468;
const productId2 = 9117318185148;
  

  try {
    const res = await fetch('/cart.js');
const cart = await res.json();

 const updates = {};
    cart.items.forEach(item => {
      if (item.product_id == productId) {
        updates[item.key] = 0; // use item.key with update.js
      }
      if (item.product_id == productId2) {
        updates[item.key] = 0; // use item.key with update.js
      }

    });
 
 const updateRes = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });

    const updated = await updateRes.json();
    console.log('Removed matching items:', updated);


 //setTimeout(async function () {
// Continue processing
const cartData = await getCartData();
console.log("cartData", cartData);

if (cartData.success) {
  for (const item of cartData.items) {
    await handleStitchesLogoService(item);
  }
  // redirect
  window.location.href = '/cart';
 // return;
}
//}, 2500);

// Fallback if needed
// location.reload();
hideLoader();

  } catch (error) {
    console.error("Error processing cart:", error);
    hideLoader();
  }
}

});

function showLoader() {
  $(".loaderdiv").show();
}

function hideLoader() {
  $(".loaderdiv").hide();
}
